export const NotFoundPageConstants = {
  PageTitle: 'Page not found',
  PageParagraph: 'We couldn’t find the page you’re looking for. Are you sure the website URL is correct?',
  ButtonLabel: 'Start again',
} as const
